var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", [
    _c(
      "div",
      { staticClass: "col-sm-12", attrs: { id: "dataTable" } },
      [
        _vm.isLoading
          ? _c("l-progress", {
              staticClass: "mb-2",
              attrs: {
                value: 100,
                height: 20,
                type: "info",
                animated: true,
                striped: true
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.failedToGetData,
                expression: "failedToGetData"
              }
            ],
            staticClass: "refresh-modal"
          },
          [
            _c("p", [_vm._v("Failed To Get Data")]),
            _vm._v(" "),
            _c("div", { staticClass: "refresh-button text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.getDataTable()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "sync-alt" } }),
                  _vm._v(" Reload")
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            ref: "paginatedTable",
            staticStyle: { width: "100%" },
            attrs: {
              stripe: "",
              data: _vm.tableData,
              "default-sort": {
                prop: _vm.pagination.order,
                order: _vm.pagination.ascending ? "ascending" : "descending"
              },
              "caption-top": ""
            },
            on: { "sort-change": _vm.onSortChange }
          },
          [
            _vm._l(_vm.tableColumns, function(column) {
              return _c("el-table-column", {
                key: column.label,
                attrs: {
                  "min-width": 100,
                  prop: column.prop,
                  label: column.label,
                  align: column.isToggle ? "center" : column.align
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(slot) {
                      return [
                        column.sortable
                          ? _c(
                              "div",
                              {
                                staticClass: "pointer lh-normal p-0",
                                attrs: { title: column.label },
                                on: {
                                  click: function($event) {
                                    _vm.doSorting(column.prop)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n          " + _vm._s(column.label) + " "
                                ),
                                _vm.pagination.order !== column.prop
                                  ? _c("font-awesome-icon", {
                                      attrs: { icon: "sort" }
                                    })
                                  : _vm.pagination.order === column.prop &&
                                    _vm.pagination.ascending === 0
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "sort-up" }
                                      })
                                    : _vm.pagination.order === column.prop &&
                                      _vm.pagination.ascending === 1
                                      ? _c("font-awesome-icon", {
                                          attrs: { icon: "sort-down" }
                                        })
                                      : _vm._e()
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "lh-normal p-0",
                                attrs: { title: column.label }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(column.label) +
                                    "\n          "
                                )
                              ]
                            )
                      ]
                    }
                  },
                  {
                    key: "unit",
                    fn: function(slot) {
                      return [
                        _vm._v("\n          " + _vm._s(column) + "\n        ")
                      ]
                    }
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        column.hasCustomSlot
                          ? _vm._t("content_" + column.prop, null, {
                              rowData: scope.row
                            })
                          : column.needCurrency
                            ? [
                                _c("div", { class: "text-" + column.align }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row[column.prop] !== null
                                        ? _vm.$formatCurrency(
                                            _vm.$store.getters[
                                              "account/accountData"
                                            ].account.locale,
                                            scope.row[column.prop]
                                          )
                                        : "-"
                                    )
                                  )
                                ])
                              ]
                            : column.isNumeric
                              ? [
                                  _vm._v(
                                    _vm._s(
                                      scope.row[column.prop] !== null
                                        ? parseFloat(scope.row[column.prop]) + 0
                                        : "-"
                                    )
                                  )
                                ]
                              : column.formatThisDate
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        scope.row[column.prop] !== null
                                          ? _vm.formatDate(
                                              scope.row[column.prop]
                                            )
                                          : "-"
                                      )
                                    )
                                  ]
                                : column.isToggle
                                  ? [
                                      _c("l-switch", {
                                        staticClass: "ml-2",
                                        attrs: {
                                          width: 30,
                                          type: "primary",
                                          "active-value": 1,
                                          "inactive-value": 0
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.changeSwitch(
                                              column.prop,
                                              column.label,
                                              scope.row.id,
                                              scope.row[column.prop]
                                            )
                                          }
                                        },
                                        model: {
                                          value: scope.row.isActive,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "isActive", $$v)
                                          },
                                          expression: "scope.row.isActive"
                                        }
                                      })
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        { class: "text-" + column.align },
                                        [_vm._v(_vm._s(scope.row[column.prop]))]
                                      )
                                    ]
                      ]
                    }
                  }
                ])
              })
            }),
            _vm._v(" "),
            !_vm.noActions
              ? _c("el-table-column", {
                  attrs: { width: 115, align: "center", label: "Actions" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm.hasSlot("actionButtons")
                            ? [
                                _vm._t("actionButtons", null, {
                                  rowData: scope.row
                                })
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hasSlot("actionButtons")
                            ? [
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "justify-content-center table-actions"
                                  },
                                  [
                                    _vm.canPrint
                                      ? [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "mb-0 text-center detail mr-1",
                                              attrs: {
                                                variant: "warning",
                                                size: "sm"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.doPrintStruct(
                                                    scope.row.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-print"
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canShow && !_vm.customShow
                                      ? [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "mb-0 text-center detail mr-1",
                                              attrs: {
                                                variant: "info",
                                                size: "sm",
                                                href:
                                                  _vm.getLastPathUrl() +
                                                  scope.row.id
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-info"
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.customShow
                                      ? [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "mb-0 text-center detail mr-1",
                                              attrs: {
                                                variant: "info",
                                                size: "sm",
                                                href:
                                                  _vm.customUrl + scope.row.id
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-info"
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canEdit &&
                                    !_vm.modalView &&
                                    scope.row.status !== "Paid" &&
                                    scope.row.status !== "Canceled"
                                      ? [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "mb-0 text-center edit",
                                              attrs: {
                                                variant: "primary",
                                                size: "sm",
                                                href:
                                                  _vm.getLastPathUrl() +
                                                  scope.row.id +
                                                  "/edit"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-pencil-alt"
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.modalView
                                      ? [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "mb-0 text-center edit",
                                              attrs: {
                                                variant: "primary",
                                                size: "sm"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.doEdit(scope.row)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-pencil-alt"
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canDelete
                                      ? [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "mb-0 text-center delete ml-1",
                                              attrs: {
                                                variant: "danger",
                                                size: "sm",
                                                type: "button"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  _vm.doDeleteData(scope.row.id)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-trash"
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              : _vm._e()
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.pagination.total > _vm.dataLimit
      ? _c(
          "div",
          {
            staticClass:
              "col-12 mt-2 d-flex justify-content-center justify-content-sm-between flex-wrap"
          },
          [
            _c("div", {}, [
              _c("p", { staticClass: "card-category" }, [
                _vm._v(
                  "Showing " +
                    _vm._s(_vm.from + 1) +
                    " to " +
                    _vm._s(_vm.to) +
                    " of " +
                    _vm._s(_vm.pagination.total) +
                    " entries"
                )
              ])
            ]),
            _vm._v(" "),
            _c("l-pagination", {
              staticClass: "pagination-no-border",
              attrs: { "per-page": _vm.dataLimit, total: _vm.pagination.total },
              on: { changePage: _vm.onChangePage },
              model: {
                value: _vm.pagination.currentPage,
                callback: function($$v) {
                  _vm.$set(_vm.pagination, "currentPage", $$v)
                },
                expression: "pagination.currentPage"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "bubble-info" }, [
      _c("div", { staticClass: "btn btn-secondary" }, [
        _c("strong", [
          _vm._v("Total Omset : " + _vm._s(_vm.formatNumber(_vm.totalOmset)))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn btn-success" }, [
        _c("strong", [
          _vm._v("Total Profit : " + _vm._s(_vm.formatNumber(_vm.totalProfit)))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dc2d11f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc2d11f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tables/PaginatedTableWithResource.vue
// module id = bixX
// module chunks = 4